import { loadingLottie } from "assets/lottie";
import {
  black,
  gray1,
  gray2,
  gray4,
  gray5,
  gray6,
  gray7,
  gray8,
  mainColor,
  mainDark1Color,
  red,
  white,
} from "assets/styleUtils";
import { DateField, GuideBox, Header } from "components";
import Lottie from "lottie-react";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetcher } from "utils/ApiUtil";
import { getParameterObject } from "utils/common";
import moment from "moment";
import "moment/locale/ko";
import { InquiryListItem } from "./InquiryListItem";
import useModal from "hooks/useModal";
import { toast, ToastContainer } from "react-toastify";
import Calendar from "react-calendar";
import styles from "./style.module.css";
import "./calendar.style.css";
import {
  cancelInquiryBox,
  changeInquiryBox,
  IClosedDate,
  TCompanyClosedHoliday,
  TContructorClosedHoliday,
} from "data/company";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  etcRecombinationListState,
  recombinationListState,
} from "recoil/company";
import { THall } from "pages/WeddingHall/WeddingHall";
import useInitData from "hooks/useInitData";
import { userSelectHall } from "recoil/atoms";
import { ButtonModal } from "modal";
import { SvgReload } from "assets";
import { AlertModal } from "./AlertModal";
import { headerState } from "recoil/header";

type TTabNo = 0 | 1 | 2 | 3;
const statusMapping: { [key in TTabNo]: string } = {
  0: "접수중",
  1: "예약완료",
  2: "계약완료",
  3: "취소",
};

type TCancelReasonNo = 0 | 1 | 2 | 3 | 4;
const cancelReasonList: { value: TCancelReasonNo; text: string }[] = [
  { value: 0, text: "다른 업체를 예약했어요." },
  { value: 1, text: "다른 플랫폼으로 예약했어요" },
  { value: 2, text: "잘못 신청했어요" },
  { value: 3, text: "단순히 마음이 바뀌었어요." },
  { value: 4, text: "업체에서 예약을 취소했어요." },
];

export type UpdateListType = {
  no: number;
  status?: number;
  cancel?: "Y" | "N";
};

interface ExtraData {
  title: string;
  content: string;
  category: string;
}

interface ISpotData {
  contructor_no: number;
  createdAt: string;
  createdDt: string;
  name: string;
  no: number;
  updatedAt: string;
  updatedDt: string;
}

interface IContractData {
  no: number;
  seat: number;
  deposit: string;
  invoice: string;
  user_no: number;
  createdAt: number;
  updatedAt: number;
  estimate_no: number;
  wedding_day: string;
  contract_day: string;
  contructor_no: number;
  wedding_hall_name: string;
  contructor_hall_no: number;
  estimate_sub_no: number;
}

export interface IInquiry {
  no: number;
  log?: { cancel_cnt: number; change_cnt: number };
  user_no: number;
  title: string;
  all_estimate: number;
  createdAt: string;
  updatedAt?: string;
  createdDt?: string;
  updatedDt?: string;
  status?: number;
  extra_data?: ExtraData[];
  extra_data_title?: string;
  category: string;
  category_no: number;
  contract_day: string;
  contructor_estimate: number;
  contructor_img: string;
  contructor_name: string;
  contructor_no: number;
  contructor_spot_no: string | null;
  counsel_day: string;
  counsel_days: string | null;
  counsel_time: string | null;
  contract_product: string | null;
  counsel_open_day: string | null;
  counsel_open_time: string | null;
  counsel_open_point: string | null;
  counsel_cancel_day: string | null;
  counsel_change_day: string | null;
  counsel_cancel_reason: string | null;
  counsel_change_reason: string | null;
  counsel_point: string;
  contract: IContractData | null;
  spot: ISpotData | null;
  estimate_no: number;
  hall: THall[] | null;
  closed_date?: IClosedDate[] | null;
  closed_holidays?: string;
  closed_weekdays?: string;
  advertising_yn?: "Y" | "N";
}
export interface EtcRankInfo {
  date: string | null;
  time: string | null;
}
export type applyButtonType = "cancel" | "weddingChange" | "etcChange";

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

export interface IInquiryWithCompanyPicture extends IInquiry {
  img_url_thumb?: string;
  sublist: IInquiry[];
  wedding_day: string;
}

export interface IInquiryListData {
  result: IInquiryWithCompanyPicture[];
}

export async function getInquiryBoxList({ type }: { type: string }) {
  return await fetcher<IInquiryListData>("/api/user/estimatelist", {
    type,
  });
}

async function getClosedHolidayList() {
  return await fetcher<{ result: TContructorClosedHoliday }>(
    "/api/contructor/getClosedHolidayList",
  );
}

export default function InquiryBoxList() {
  const { search } = useLocation();
  const { type, status } = getParameterObject({ url: search }) as {
    type: "wedding" | "etc";
    status: string;
  };
  const { getInquiryList } = useInitData();
  const [selectArray, setSelectArray] = useRecoilState(userSelectHall);

  const recombinationList = useRecoilValue(recombinationListState);
  const etcRecombinationList = useRecoilValue(etcRecombinationListState);
  const [inquiryBoxList, setInquiryBoxList] =
    useState<IInquiry[]>(recombinationList);
  const [isLoading, setIsLoading] = useState(true);
  const [selectTabNo, setSelectTabNo] = useState<TTabNo>(
    (Number(status) as TTabNo) || 0,
  );
  const navigate = useNavigate();
  const [select, setSelect] = useState<IInquiry[]>([]);
  const handleSelectSingleItem = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    item: IInquiry,
  ) => {
    e.stopPropagation();
    if (select.includes(item)) {
      setSelect([]);
    } else {
      setSelect([item]);
    }
  };
  const { visibleModal, removeModal } = useModal();
  const [showAlert, setShowAlert] = useState(false);
  const [cancelText, setCancelText] = useState<string>();
  const [modalType, setModalType] = useState<applyButtonType>();
  const [selectTime, setSelectTime] = useState<string>();
  const [otherTask, setOtherTask] = useState<string>();
  const [selectDate, useSelectDate] = useState<
    Date | null | [ValuePiece, ValuePiece]
  >();
  const [etcSelectChangeDate, setEtcSelectChangeDate] = useState<EtcRankInfo[]>(
    [],
  );
  const setHeader = useSetRecoilState(headerState);

  setHeader({
    isVisible: true,
    title: "문의내역",
    left: "back",
  });
  //날짜기준으로 sorting
  function sortByCounselDays(
    type: "wedding" | "etc",
    a: IInquiry,
    b: IInquiry,
  ) {
    let aDate: string | null;
    let bDate: string | null;

    if (type === "etc") {
      aDate = a.counsel_open_day || a.counsel_days;
      bDate = b.counsel_open_day || b.counsel_days;
    } else {
      aDate = a.counsel_days;
      bDate = b.counsel_days;
    }

    if (aDate === null) return 1;
    if (bDate === null) return -1;

    return aDate.localeCompare(bDate);
  }

  const sortingCombinationList = (
    type: "wedding" | "etc",
    list: IInquiry[],
  ) => {
    return [...list].sort((a, b) => sortByCounselDays(type, a, b));
  };
  function ButtonsComponent({
    check,
    type,
    cancelReason,
    changeDate,
    changeTime,
    etcChangeObject,
  }: {
    check: boolean;
    type: applyButtonType;
    cancelReason?: {
      value?: number;
      text?: string;
    };
    changeDate?: string;
    changeTime?: string;
    etcChangeObject?: EtcRankInfo[];
  }) {
    if (type === "cancel") {
      setModalType("cancel");
    }
    if (type === "etcChange") {
      setModalType("etcChange");
    }
    if (type === "weddingChange") {
      setModalType("weddingChange");
    }

    return (
      <div className={styles.modalButtonContainer}>
        <button
          style={{
            backgroundColor: gray8,
            marginRight: "10px",
            color: black,
            fontWeight: "bolder",
            border: `1px solid ${gray6}`,
          }}
          onClick={() =>
            removeModal(type === "cancel" ? "CANCEL_MODAL" : "CHANGE_MODAL")
          }
        >
          뒤로가기
        </button>
        <button
          style={{
            backgroundColor: !!check ? mainDark1Color : gray7,
            color: !!check ? white : gray6,
          }}
          onClick={() => {
            if (type === "cancel" && !cancelReason?.text) {
              return;
            }
            if (type === "weddingChange" && (!changeDate || !changeTime)) {
              return;
            }
            if (
              type === "etcChange" &&
              etcChangeObject?.every(
                (rankcheck) => !rankcheck.date || !rankcheck.time,
              )
            ) {
              return;
            } else {
              setShowAlert(true);
            }
          }}
        >
          선택완료
        </button>
      </div>
    );
  }
  //예약취소, 예약변경 카운트
  const [selectNo, setSelectNo] = useState(0);
  const [selectContructNo, setSelectContructNo] = useState(0);
  const [limitRequest, setLimitRequest] = useState(false);
  const [blockToApply, setBlockToApply] = useState(false);

  const [checkChange, setCheckChange] = useState(false);
  const date = new Date();
  const momentToday = moment(date).format("YYYY-MM-DD");
  const handleSelectNoAndContructNo = useCallback(
    (selectedNo: number, selectedContructNo: number) => {
      setSelectNo(selectedNo);
      setSelectContructNo(selectedContructNo);
    },
    [setSelectNo, setSelectContructNo],
  );

  // 휴무일설정
  const [initClosedHolidayList, setInitClosedHolidayList] =
    useState<TContructorClosedHoliday>();

  async function getHolidayList() {
    const { success, data } = await getClosedHolidayList();
    if (success) {
      setInitClosedHolidayList(data.result);
    }
  }

  function checkToPreviousWedding(handleButton: applyButtonType) {
    if (selectNo === 0) {
      return toast.error("업체명을 선택해주세요");
    }
    const filterEstimate = (inquiryBoxList || []).filter(
      (list) =>
        selectNo === list.estimate_no &&
        selectContructNo === list.contructor_no,
    );
    const threeDaysBefore = moment(filterEstimate[0].counsel_days)
      .subtract(3, "days")
      .format("YYYY-MM-DD");

    if (!moment(momentToday).isSameOrBefore(threeDaysBefore, "day")) {
      return setBlockToApply(true), setShowAlert(true);
    }
    if (!!filterEstimate[0].counsel_change_day) {
      setCheckChange(true);
    } else {
      setCheckChange(false);
    }
    const logData = filterEstimate[0]?.log;
    if (!!logData && logData.cancel_cnt + logData.change_cnt >= 1) {
      setLimitRequest(true);
      setShowAlert(true);
    } else {
      setLimitRequest(false);
      clickToChange(handleButton);
    }
  }

  function checkToDateEtc(handleButton: applyButtonType) {
    if (selectNo === 0) {
      return toast.error("업체명을 선택해주세요");
    }
    const filterEstimate = (inquiryBoxList || []).filter(
      (list) =>
        selectNo === list.estimate_no &&
        selectContructNo === list.contructor_no,
    );

    // filterEstimate[0].counsel_open_day은 기타 상담 예약 변경일자, filterEstimate[0].counsel_days는 상담 일자
    const threeDaysBefore = moment(
      filterEstimate[0].counsel_open_day || filterEstimate[0].counsel_days,
    )
      .subtract(3, "days")
      .format("YYYY-MM-DD");

    if (!moment(momentToday).isSameOrBefore(threeDaysBefore, "day")) {
      return setBlockToApply(true), setShowAlert(true);
    } else {
      clickToChange(handleButton);
    }
  }

  function clickToChange(handleButton: applyButtonType) {
    if (select.length > 0) {
      openSorting(handleButton);
    } else {
      toast.error("업체명을 선택해주세요");
    }
  }

  function CancelModalContent() {
    const [cancelChoice, setCancelChoice] = useState<{
      value?: number;
      text?: string;
    }>();
    const clickCancelData = (data: { value?: number; text?: string }) => {
      setCancelChoice(data);
      if (data.text) {
        setCancelText(data.text);
      }
    };
    return (
      <>
        <div style={{ padding: "20px 24px 0px 24px", zIndex: 102 }}>
          <div
            style={{ height: "30px", fontSize: "16px", fontWeight: "bolder" }}
          >
            취소 사유를 선택해주세요
          </div>
          {cancelReasonList.map((data, index) => (
            <div
              key={index}
              style={{
                width: "100%",
                height: "40px",
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div className={styles.radio}>
                <input
                  type="radio"
                  name="cancelList"
                  onClick={() => clickCancelData(data)}
                />
                <span />
              </div>
              <div style={{ marginLeft: "10px" }}>{data.text}</div>
            </div>
          ))}
          <ButtonsComponent
            check={!!cancelChoice}
            type="cancel"
            cancelReason={cancelChoice}
          />
        </div>
      </>
    );
  }

  function WeddingChangeModalContent() {
    const [date, onChange] = useState<Date | null | [ValuePiece, ValuePiece]>(
      new Date(),
    );
    const [inModalTime, setInModalTime] = useState<string>();
    const [inModalTask, setInModalTask] = useState<string>();
    const check = !!date && !!inModalTime;
    if (!!date) {
      useSelectDate(date);
    }
    if (!!inModalTime) {
      setSelectTime(inModalTime);
    }
    if (!!inModalTask) {
      setOtherTask(inModalTask);
    }
    return (
      <div style={{ padding: "20px 24px 0px 24px" }}>
        <section>
          <article className={styles.calendarContainer}>
            <Calendar
              value={date}
              maxDetail="month"
              onChange={onChange}
              formatDay={(locale, date) => moment(date).format("DD")}
            />
          </article>

          <form className={styles.requestForm}>
            <div className={styles.requestItem}>
              <div className={styles.label}>변경 요청 날짜</div>
              <span id="requestDate">
                {date instanceof Date && moment(date).isValid()
                  ? moment(date).format("YYYY-MM-DD") +
                    " " +
                    moment(date).format("dd")
                  : ""}
              </span>
            </div>

            <div className={styles.requestItem}>
              <div className={styles.label}>변경 요청 시간</div>
              <div id="timeContainer" style={{ display: "flex" }}>
                <label htmlFor="appt-time" className={styles.hideClock}>
                  🕖
                </label>
                <input
                  className={styles.weddingChangeInput}
                  id="appt-time"
                  type="time"
                  name="appt-time"
                  required
                  onChange={(e) => setInModalTime(e.target.value)}
                />
                <span className="validity"></span>
              </div>
            </div>

            <div className={styles.requestItem}>
              <label className={styles.label}>기타 문의 사항</label>
              <input
                type="text"
                placeholder={`입력해주세요`}
                onChange={(e) => setInModalTask(e.target.value)}
              />
            </div>
          </form>
        </section>
        <ButtonsComponent
          check={check}
          type="weddingChange"
          changeDate={moment(date as Date).format("YYYY-MM-DD")}
          changeTime={inModalTime}
        />
      </div>
    );
  }
  function EtcChangeModalContent() {
    const priorityNum = ["1순위", "2순위", "3순위"];
    const [inModalTask, setInModalTask] = useState<string>();
    const [etcRankInfo, setEtcRankInfo] = useState<EtcRankInfo[]>([
      { date: null, time: null },
      { date: null, time: null },
      { date: null, time: null },
    ]);
    const etcChangeCheck = etcRankInfo.every(
      (rankcheck) => !!rankcheck.date && !!rankcheck.time,
    );

    const filterEstimate = (inquiryBoxList || []).filter(
      (list) =>
        selectNo === list.estimate_no &&
        selectContructNo === list.contructor_no,
    );

    // 휴무일
    const closedHoliday = filterEstimate[0]?.closed_holidays;
    const closedHolidayList = (closedHoliday || "")
      .split(",")
      .filter((item) => !!item) as TCompanyClosedHoliday[];

    console.log(closedHolidayList, initClosedHolidayList);

    const closedDateList: IClosedDate[] = (
      filterEstimate[0]?.closed_date || []
    ).map((item) => ({
      closed_date: item.closed_date,
    }));

    closedHolidayList.map((holiday) => {
      if (holiday in (initClosedHolidayList || {})) {
        initClosedHolidayList?.[holiday].map((closed_date) => {
          closedDateList.push({ closed_date });
        });
      }
    });

    const closedWeekday = filterEstimate[0]?.closed_weekdays;

    if (!!etcChangeCheck) {
      setEtcSelectChangeDate(etcRankInfo);
    }
    if (!!inModalTask) {
      setOtherTask(inModalTask);
    }
    const handleDateChange = (selectedDate: string, index: number) => {
      const duplicateIndex = etcRankInfo.findIndex(
        (item, i) => item.date === selectedDate && i !== index,
      );
      if (duplicateIndex !== -1) {
        setEtcRankInfo((current) =>
          current.map((item, i) =>
            i === index ? { ...item, date: null } : { ...item },
          ),
        );
        return toast.error("1~3순위 동일한 날짜 선택이 불가합니다.");
      } else {
        setEtcRankInfo((current) =>
          current.map((item, i) =>
            i === index ? { ...item, date: selectedDate } : { ...item },
          ),
        );
      }
    };

    const handleTimeChange = (selectedTime: string, index: number) => {
      setEtcRankInfo((current) =>
        current.map((item, i) =>
          i === index ? { ...item, time: selectedTime } : item,
        ),
      );
    };
    return (
      <div style={{ padding: "20px 24px 0px 24px" }}>
        <section className={styles.etcSection}>
          <h3>변경일자 1 ~ 3순위까지 입력해주세요.</h3>
          <h5 style={{ color: red }}>
            * 3순위까지 각각 다른 날짜로 입력해주세요.
            <p>
              모두 동일한 날짜로 입력 시 변경이 불가한 날짜인 경우 예약 변경되지
              않습니다.
            </p>
          </h5>
          {priorityNum.map((num, i) => (
            <li key={i}>
              <label>{num} 희망일자, 시간*</label>
              <div>
                <DateField
                  index={i}
                  onChange={(date: string) => handleDateChange(date, i)}
                  value={etcRankInfo[i].date || ""}
                  closedDate={closedDateList}
                  closedWeekday={closedWeekday}
                />
                <input
                  type="text"
                  required
                  placeholder="예) 오전 9시"
                  onChange={(e) => handleTimeChange(e.target.value, i)}
                />
              </div>
            </li>
          ))}

          <li>
            <label className={styles.label}>기타 문의 사항</label>
            <div>
              <input
                type="text"
                placeholder={`입력해주세요`}
                onChange={(e) => setInModalTask(e.target.value)}
                style={{
                  borderBottom: "1px solid #e2e2e2",
                  width: "225px",
                  height: "45px",
                }}
              />
            </div>
          </li>
        </section>
        <ButtonsComponent
          check={etcChangeCheck}
          type="etcChange"
          etcChangeObject={etcRankInfo}
        />
      </div>
    );
  }

  function updateSublist({ no, status, cancel }: UpdateListType) {
    setInquiryBoxList((prevData) => {
      return prevData.map((item) => {
        if (item.no === no && status !== 3) {
          return {
            ...item,
            status: status,
            counsel_cancel_day: cancel === "Y" ? "yes" : null,
            counsel_change_day: cancel === "N" ? "yes" : null,
          };
        }

        return item;
      });
    });
  }

  function getSublistCountByStatus(targetStatus: number) {
    return inquiryBoxList.filter((item) => {
      if (targetStatus === 3) {
        return (
          !!item.counsel_cancel_day ||
          item.status === targetStatus ||
          (!!item.counsel_open_day && !!item.counsel_cancel_reason)
        );
      } else {
        return (
          item.status === targetStatus &&
          !item.counsel_cancel_day &&
          !(!!item.counsel_open_day && !!item.counsel_cancel_reason)
        );
      }
    });
  }
  function openSorting(handleButton: applyButtonType) {
    if (handleButton === "cancel") {
      visibleModal({
        id: "CANCEL_MODAL",
        edge: "bottom",
        modalchildren: <CancelModalContent />,
      });
    }
    if (handleButton === "weddingChange") {
      visibleModal({
        id: "CHANGE_MODAL",
        edge: "bottom",
        modalchildren: <WeddingChangeModalContent />,
      });
    }
    if (handleButton === "etcChange") {
      visibleModal({
        id: "CHANGE_MODAL",
        edge: "bottom",
        modalchildren: <EtcChangeModalContent />,
      });
    }
  }

  function reReserveButton() {
    navigate(`/wedding/hall?txt=${select[0].contructor_name}`);
    setSelectArray([]);
  }

  function renderGuideBox({
    type,
    status,
  }: {
    type: "wedding" | "etc";
    status: number;
  }) {
    if (type === "wedding") {
      switch (status) {
        case 0:
          return (
            <GuideBox
              title="*필독*"
              list={[
                "<span>주말 및 공휴일, 영업시간 이후의 문의 건은 업체 측에 전달이 늦어질 수 있습니다. <br/> (메이크마이웨딩 영업시간: 월 ~ 금, 09:00 ~ 18:00 , 토요일 9:00 ~ 12:00)</span>",
                "업체에 이미 연락하신 이력이 있으신 경우(타 컨설팅 업체를 통한 예약 등) 중복 접수로 접수 되지 않으며, 예약 후 취소하신 경우에도 중복에 해당되어 메이크마이웨딩을 통한 예약은 불가합니다",
                "웨딩홀 예약 접수는 '최대 5회'까지만 진행 가능합니다. 웨딩홀 예약 이후 취소하셔도 '예약 접수' 기준으로 카운팅되며 횟수 초과 시 메이크마이웨딩을 통한 추가 예약은 불가한 점 양해 부탁 드립니다.",
                "예약 완료 후 당일 취소 시 베뉴센터와 웨딩홀 모두 업무에 혼선이 발생하여 다른 분들의 예약이 어려워집니다. 당일 취소의 경우 패널티가 부여되어 추가 웨딩홀 예약이 불가합니다.",
                "캐시백의 경우 웨딩홀에 따라 지급조건이 상이합니다. 상담시 안내 도와드리겠습니다.",
                "제휴 상황에 따라 혜택 제공이 변동될 수 있습니다.",
                "희망 상담 시간 마감시, 잔여 상담시간 우선적 예약해드리고 있습니다.",
                "어플 관련 오류 및 불편사항, 문의사항은 오른쪽 하단 챗봇으로 문의주세요.",
              ]}
            />
          );
        case 1:
          return (
            <div>
              <div className={styles.statusCancelButton}>
                <button
                  style={{ backgroundColor: gray5 }}
                  onClick={() => checkToPreviousWedding("cancel")}
                >
                  예약취소하기
                </button>
                <button
                  style={{ backgroundColor: gray2 }}
                  onClick={() => {
                    checkToPreviousWedding("weddingChange");
                  }}
                >
                  일정변경하기
                </button>
              </div>
              <GuideBox
                title="*필독*"
                list={[
                  "<span>주말 및 공휴일, 영업시간 이후의 문의 건은 업체 측에 전달이 늦어질 수 있습니다.<br/> (메이크마이웨딩 영업시간: 월 ~ 금, 09:00 ~ 18:00 , 토요일 9:00 ~ 12:00)</span>",
                  "예약 변경&취소 가능 회수는 웨딩홀별 총 1회로 추가 변경 및 취소는 어렵습니다. 웨딩홀에 직접 연락하여 일정 변경&방문 취소 부탁 드립니다. 감사합니다.",
                  "예약후 신랑, 신부님께서 직접 예약 변경 가능하십니다만, 변경되신 일정을 반드시 챗봇으로 안내부탁드립니다.",
                  "예약 완료 후 당일 취소 시 베뉴센터와 웨딩홀 모두 업무에 혼선이 발생하여 다른 분들의 예약이 어려워집니다. 당일 취소의 경우 패널티가 부여되어 추가 웨딩홀 예약이 불가합니다.",
                  "캐시백의 경우 웨딩홀에 따라 지급조건이 상이합니다. 상담시 안내 도와드리겠습니다.",
                  "노쇼시 멕마웨에서 제공되는 모든 혜택 및 이벤트 대상에서 제외됩니다.",
                  "어플 관련 오류 및 불편사항, 문의사항은 오른쪽 하단 챗봇으로 문의주세요.",
                ]}
              />
            </div>
          );
        case 2:
          return (
            <GuideBox
              title="*필독*"
              list={[
                "<span>주말 및 공휴일, 영업시간 이후의 문의 건은 업체 측에 전달이 늦어질 수 있습니다.<br/> (메이크마이웨딩 영업시간: 월 ~ 금, 09:00 ~ 18:00 , 토요일 9:00 ~ 12:00)</span>",
                "캐시백의 경우 웨딩홀에 따라 지급조건이 상이합니다. 상담시 안내 도와드리겠습니다.",
                "계약 10일 이내에 어플 내 [내정보] -> [계약포인트 신청] 탭에서 캐시백 신청 부탁드립니다.",
                "어플 관련 오류 및 불편사항, 문의사항은 오른쪽 하단 챗봇으로 문의주세요.",
              ]}
            />
          );
        case 3:
          return (
            <div>
              <div className={styles.statusCancelButton}>
                <button
                  style={{ backgroundColor: mainColor }}
                  onClick={() =>
                    select.length > 0
                      ? reReserveButton()
                      : toast.error("업체명을 선택해주세요")
                  }
                >
                  재예약하기
                </button>
                <button
                  style={{ backgroundColor: mainDark1Color }}
                  onClick={() => navigate("/wedding/hall")}
                >
                  다른 웨딩홀 둘러보기
                </button>
              </div>
              <GuideBox
                title="*필독*"
                list={[
                  "<span>주말 및 공휴일, 영업시간 이후의 문의 건은 업체 측에 전달이 늦어질 수 있습니다.<br/> (메이크마이웨딩 영업시간: 월 ~ 금, 09:00 ~ 18:00 , 토요일 9:00 ~ 12:00)</span>",
                  "어플 관련 오류 및 불편사항, 문의사항은 오른쪽 하단 챗봇으로 문의주세요.",
                ]}
              />
            </div>
          );
        default:
          return null;
      }
    }
    if (type === "etc") {
      switch (status) {
        case 0:
          return (
            <GuideBox
              title="*필독*"
              list={[
                "예약 문의를 주시면 업체 측 확인 후 순차적으로 안내 드립니다.",
                "원활한 예약센터 운영을 위해 타 고객 예약에 영향을 미치거나 업체 측 업무에 혼선을 줄 수 있는 경우 (예약 신청 후 업체 측 연락을 받지 않으시거나, 미회신/예약 신청일 당일 취소 요청/예약 확정일 당일 취소 요청/방문 예약 후 노쇼/이미 예약 된 이후 중복 접수 등)의 경우 패널티가 부여됩니다. <br/><span>(패널티 : 어플&베뉴 예약센터 이용 불가)</span>",
                "메이크마이웨딩을 통한 '최초' 예약일 경우에만 예약이 가능합니다. 업체에 이미 예약 및 문의하신 이력이 있으신 경우 중복으로 접수되지 않으며, 예약 후 취소하신 경우에도 중복에 해당되어 메이크마이웨딩을 통한 예약 및 혜택 지급은 불가합니다. <br/><span>(멕마웨 접수 후 예약 확정 전 업체에 문의/타경로/타업체/직접 연락을 통한 예약 또는 문의/카카오톡/문자/전화/SNS 메세지 단순 문의 등)</span>",
                "업체 별 1회 예약 가능하며, 예약 취소 된 업체는 재예약 불가합니다. (업체 일정 미오픈 등 다른 사유로 예약 불가한 경우에는 재예약 가능하며, 이런 경우 채팅으로 안내 드립니다.)",
                "방문일을 기재해야 하는 업체는 반드시 1~3순위까지 각각 '다른' 날짜로 입력 부탁드리며, 우선순위 순으로 상담 가능한 시간으로 예약을 잡아드립니다.",
                "제휴 상황에 따라 혜택 제공이 변동될 수 있습니다.",
                "메이크마이웨딩 어플을 통한 계약이 아니신 경우 포인트 적립 및 혜택 적용이 불가합니다.",
              ]}
            />
          );
        case 1:
          return (
            <div>
              <div className={styles.statusCancelButton}>
                <button
                  style={{ backgroundColor: gray5 }}
                  onClick={() => checkToDateEtc("cancel")}
                >
                  예약취소하기
                </button>
                <button
                  style={{ backgroundColor: gray2 }}
                  onClick={() => {
                    if (select[0]?.counsel_open_day) {
                      toast.error(
                        "이미 변경 하신 이력이 있으셔서 추가 요청은 불가합니다. \n업체에 직접 연락하여 변경해 주세요! :)",
                      );
                    } else if (!!select[0]?.counsel_change_day) {
                      toast.error(
                        "예약 변경 확인중이므로 예약변경이 어렵습니다.",
                      );
                    } else {
                      checkToDateEtc("etcChange");
                    }
                  }}
                >
                  일정변경하기
                </button>
              </div>
              <GuideBox
                title="*필독*"
                list={[
                  "업체를 통해 직접 예약 일정을 변경하시거나 취소하셨을 경우 메이크마이웨딩 챗봇으로 꼭 말씀 부탁드리겠습니다.",
                  "어플을 통한 예약 취소 및 변경은 각 1회씩 예약된 날짜로부터 3일 전까지만 가능하며, 2일 이내일 경우 업체에 직접 신청해 주셔야 합니다.",
                  "제휴 상황에 따라 혜택 제공이 변동될 수 있습니다.",
                  "원활한 예약센터 운영을 위해 타 고객 예약에 영향을 미치거나 업체 측 업무에 혼선을 줄 수 있는 경우 (예약 신청 후 업체 측 연락을 받지 않으시거나, 미회신/예약 신청일 당일 취소 요청/예약 확정일 당일 취소 요청/방문 예약 후 노쇼/이미 예약 된 이후 중복 접수 등)의 경우 패널티가 부여됩니다. <br/><span>(패널티 : 어플&베뉴 예약센터 이용 불가)</span>",
                  "업체별 취소 가능한 기간이 상이합니다. 방문이 어려우신 경우 피해 없으시도록 업체 내부 규정에 따라 미리 취소/변경 부탁드립니다. (취소 가능한 기간이 지나 예약금 및 계약금 환불이 불가할 경우 메이크마이웨딩에서 책임지지 않습니다.)",
                  "메이크마이웨딩 어플을 통한 계약이 아니신 경우 포인트 적립 및 혜택 적용이 불가합니다.",
                ]}
              />
            </div>
          );
        case 2:
          return (
            <GuideBox
              title="*필독*"
              list={[
                "계약이 진행되셨다면, 오른쪽 버튼을 클릭하시어 계약 포인트를 신청해주세요.",
                "계약 포인트는 업체 측 확인 후 지급해 드리고 있으며, 영업일 기준 3~7일 정도 소요될 수 있는 점 참고 부탁드립니다.",
                "메이크마이웨딩 어플을 통한 계약이 아니신 경우 포인트 적립 및 혜택 적용이 불가합니다.",
              ]}
            />
          );
        case 3:
          return (
            <GuideBox
              title="*필독*"
              list={[
                "<span>취소하셨던 업체 재예약은 불가하며, 업체 자체적으로 일정 불가하여 취소되셨던 경우만 챗봇으로 신청해 주세요. </span>",
              ]}
            />
          );
        default:
          return null;
      }
    }
  }

  useEffect(() => {
    if (type) {
      const sortedRecombinationList = sortingCombinationList(
        "wedding",
        recombinationList,
      );
      const sortedEtcRecombinationList = sortingCombinationList(
        "etc",
        etcRecombinationList,
      );

      const selectedList =
        type === "wedding"
          ? sortedRecombinationList
          : sortedEtcRecombinationList;

      setInquiryBoxList(selectedList);
    }
  }, [recombinationList, etcRecombinationList]);

  useEffect(() => {
    getInquiryList("wedding");
    getInquiryList("etc");
    getHolidayList();
  }, []);

  async function handleConfirm() {
    try {
      setShowAlert(false);
      if (select.length < 1) {
        return;
      }
      if (modalType === "cancel") {
        await cancelInquiryBox({
          estimate_no: select[0].estimate_no,
          estimate_sub_no: select[0].no,
          counsel_cancel_reason: cancelText,
        });
        updateSublist({
          no: select[0].no,
          status: 1,
          cancel: "Y",
        });
      }
      if (modalType === "weddingChange") {
        if (!!selectDate && !!selectTime) {
          await changeInquiryBox({
            estimate_no: select[0].estimate_no,
            estimate_sub_no: select[0].no,
            change_requests: [
              {
                date: moment(selectDate as Date).format("YYYY-MM-DD"),
                time: selectTime && selectTime,
              },
            ],
            counselChangeReason: otherTask,
          });
          updateSublist({
            no: select[0].no,
            status: 1,
            cancel: "N",
          });
          setSelect([]);
        }
      }
      if (modalType === "etcChange") {
        await changeInquiryBox({
          estimate_no: select[0].estimate_no,
          estimate_sub_no: select[0].no,
          change_requests: etcSelectChangeDate,
          counselChangeReason: otherTask,
        });
        updateSublist({
          no: select[0].no,
          status: 1,
          cancel: "N",
        });
        setSelect([]);
      }
      removeModal(modalType === "cancel" ? "CANCEL_MODAL" : "CHANGE_MODAL");
      toast.success(
        modalType === "cancel"
          ? "예약취소 신청이 완료되었습니다"
          : "예약변경 신청이 완료되었습니다",
      );
    } catch (error) {
      toast.error("챗봇으로 문의해주세요");
    }
  }

  return (
    <>
      <div style={{ padding: "16px 24px" }}>
        {showAlert && (
          <AlertModal
            onClose={() => {
              setShowAlert(false),
                setBlockToApply(false),
                setLimitRequest(false);
            }}
            limitRequest={limitRequest}
            modalType={modalType}
            type={type}
            handleConfirm={handleConfirm}
            blockToApply={blockToApply}
          />
        )}
        <div>
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ fontSize: "20px", fontWeight: "bolder" }}>
                {type === "wedding" ? "웨딩홀" : "기타"} 예약관리
              </div>
              <div
                style={{
                  cursor: "pointer",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  window.location.reload();
                }}
              >
                <SvgReload />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                height: "44px",
              }}
            >
              {([0, 1, 2, 3] as TTabNo[]).map((tabNo, i) => {
                const isSelect = tabNo === selectTabNo;
                return (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        marginTop: "10px",
                        marginRight: "20px",
                        borderBottom: isSelect ? `2px solid ${gray1}` : "",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectTabNo(tabNo)}
                    >
                      <div
                        style={{
                          color: isSelect ? gray1 : gray5,
                          fontWeight: "500",
                          display: "flex",
                          lineHeight: "180%",
                        }}
                      >
                        {statusMapping[tabNo]}
                        {getSublistCountByStatus(i).length || 0}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div>
              {selectTabNo >= 0 &&
                (inquiryBoxList || [])
                  .filter((sub) => {
                    if (selectTabNo === 3) {
                      return (
                        !!sub.counsel_cancel_day ||
                        sub.status === 3 ||
                        (!!sub.counsel_open_day && !!sub.counsel_cancel_reason)
                      );
                    }
                    return (
                      sub.status === selectTabNo &&
                      !sub.counsel_cancel_day &&
                      !(!!sub.counsel_open_day && !!sub.counsel_cancel_reason)
                    );
                  })
                  .map((_sub, idx) => (
                    <InquiryListItem
                      key={idx}
                      item={_sub}
                      type={type}
                      extra={_sub.extra_data}
                      updateList={({ no, status, cancel }: UpdateListType) =>
                        updateSublist({ no, status, cancel })
                      }
                      select={select}
                      checkHandle={handleSelectSingleItem}
                      handleSelectNoAndContructNo={handleSelectNoAndContructNo}
                    />
                  ))}
            </div>
          </div>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "30px",
              }}
            >
              {renderGuideBox({ type, status: selectTabNo })}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1300}
        theme="light"
      />
    </>
  );
}
